// Patient status (source of external medications)
export const PatientStatus = {
  DISCHARGED: 'DISCHARGED',
  EMERGENCY: 'EMERGENCY',
  ADMITTED: 'ADMITTED',
};

// Reconciliation actions
export const ReconcileAction = {
  CONTINUE: 'CONTINUE',
  STOP: 'STOP',
  MODIFY: 'MODIFY',
  NEW: 'NEW',
};

// UI labels for chips/buttons
export const ACTION_LABELS = {
  CONTINUE: 'Continue',
  STOP: 'Stop',
  MODIFY: 'Modify',
  NEW: 'New',
};

export const ACTION_SEVERITY = {
  CONTINUE: 'success',
  STOP: 'error',
  MODIFY: 'warning',
  NEW: 'info',
};

// Clinical conditions (patients may have multiple simultaneously)
export const ClinicalCondition = {
  ADMITTED: 'ADMITTED',
  DISCHARGED: 'DISCHARGED',
  EMERGENCY: 'EMERGENCY',
};

export const CONDITION_COLORS = {
  ADMITTED: 'info',      // azul
  DISCHARGED: 'success', // verde
  EMERGENCY: 'error',    // rojo
};

// Member status (0 = Active, 1 = Inactive)
export const MemberStatus = {
  ACTIVE: 0,
  INACTIVE: 1,
};

// Clinical flags shown as chips
export const ClinicalFlag = {
  ADMITTED: 'Admitted',
  DISCHARGED: 'Discharged',
  EMERGENCY: 'Emergency',
  HIGH_COST: 'High Cost',
  HIGH_RISK: 'High Risk',
};

export const FLAG_COLORS = {
  Admitted: 'info',
  Discharged: 'success',
  Emergency: 'error',
  'High Cost': 'warning',
  'High Risk': 'secondary',
};
